/*
 * Created Date: 16-08-2022, 12:47:34 am
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2022 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { ROUTER_WORKSPACE_EXAM } from '@App/Studio/Modules/Workspace/Exam/configs/const'
import { getQueryUrlObject } from './Url'
import { clearCache } from 'ahooks'
import { get } from 'lodash'

export const SESSION_STORAGE = 'session'
export const LOCAL_STORAGE = 'local'
export function setDataSession(type, key, data) {
	if (typeof Storage !== 'undefined') {
		if (!key) return false
		// process data
		// save to storegae
		data = JSON.stringify(data)
		if (type === SESSION_STORAGE) {
			sessionStorage.setItem(key, data)
			return true
		}

		if (type === LOCAL_STORAGE) {
			localStorage.setItem(key, data)
			return true
		}
	}
	return null
	// console.log('This Browser dont supported storeage');
}

export function getDataSession(type, key) {
	if (typeof Storage !== 'undefined') {
		// process data
		let value = ''
		let data = ''
		if (type === SESSION_STORAGE) {
			value = sessionStorage.getItem(key)
		}

		if (type === LOCAL_STORAGE) {
			value = localStorage.getItem(key)
		}

		try {
			data = JSON.parse(value) || null
		} catch (err) {
			data = value
		}
		return data
	}
	// console.log('This browser does not support local storage');
	return null
}

export function removeDataSession(type, key) {
	if (typeof Storage !== 'undefined') {
		if (type === SESSION_STORAGE) {
			sessionStorage.removeItem(key)
		}
		if (type === LOCAL_STORAGE) {
			localStorage.removeItem(key)
		}
	}
	// console.log('This browser does not support local storage');
}

export const setAuthTokenSession = data => {
	setDataSession(LOCAL_STORAGE, 'authToken', data)
}

export const getAuthTokenSession = () => {
	const data = getDataSession(LOCAL_STORAGE, 'authToken') ?? {}

	return data
}

export const setAuthDataSesstion = data => {
	setDataSession(LOCAL_STORAGE, 'authData', data)
}

export const getAuthDataSession = key => {
	const data = getDataSession(LOCAL_STORAGE, 'authData') ?? {}
	if (key) {
		return get(data, key)
	}
	return data
}

export const setMySchoolSession = data => {
	setDataSession(LOCAL_STORAGE, 'mySchool', data)
}

export const getMySchoolSession = key => {
	const data = getDataSession(LOCAL_STORAGE, 'mySchool') ?? {}
	if (key) {
		return data[key]
	}
	return data
}

export const setSystemSettingSession = data => {
	setDataSession(LOCAL_STORAGE, 'system_general', data)
}

export const getSystemSettingSession = key => {
	const data = getDataSession(LOCAL_STORAGE, 'system_general') ?? {}
	if (key) {
		return get(data, key)
	}
	return data
}

export const setCurrentWorkspaceSession = data => {
	setDataSession(LOCAL_STORAGE, 'current_workspace', data)
}

export const getCurrentWorkspaceSession = key => {
	const data = getDataSession(LOCAL_STORAGE, 'current_workspace') ?? {}
	if (key) {
		return data[key]
	}
	return data
}

export const clearCurrentWorkspaceSession = () => {
	localStorage.removeItem('current_workspace')
}

export const clearSession = () => {
	localStorage.clear()
	sessionStorage.clear()
}

export const setLastRouter = url => {
	if (url) setDataSession(SESSION_STORAGE, 'last_router', url)
}

export const getLastRouter = () => {
	return getDataSession(SESSION_STORAGE, 'last_router') ?? ROUTER_WORKSPACE_EXAM.list
}

export const setCampaignSale = () => {
	const query = getQueryUrlObject()
	if (query?.utm_campaign === 'xmax') {
		setDataSession(LOCAL_STORAGE, 'campaign_sale', query?.utm_campaign)
	}
}

export const getCampaignSale = () => {
	return getDataSession(LOCAL_STORAGE, 'campaign_sale')
}

export const setRoomUserDataSession = data => {
	setDataSession(SESSION_STORAGE, 'room_user-data', data)
}

export const getRoomUserDataSession = (key = null) => {
	const data = getDataSession(SESSION_STORAGE, 'room_user-data') ?? {}
	if (key) {
		return data[key]
	}
	return data
}
